import { render, staticRenderFns } from "./AlumniManagement.vue?vue&type=template&id=4d9cf9bf&scoped=true"
import script from "./AlumniManagement.vue?vue&type=script&lang=js"
export * from "./AlumniManagement.vue?vue&type=script&lang=js"
import style0 from "./AlumniManagement.vue?vue&type=style&index=0&id=4d9cf9bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9cf9bf",
  null
  
)

export default component.exports